import styled from 'styled-components';
import tw from 'twin.macro';

import { colors } from '@nw/shared/ui';

export const SliderComponent = styled.div`
  @media (min-width: 1024px) {
    ${tw`w-full px-20 mt-2`};
    .slick-prev {
      left: -57px;
    }

    .slick-next {
      right: -68px;
    }

    li.slick-active > button::before {
      color: #fff !important;
    }

    li > button::before {
      color: #e5ecff !important;
      height: 6px !important;
      width: 6px !important;
    }

    .active {
      color: #fff;
      width: 18px;
    }

    .slick-dots {
      bottom: -58px !important;
    }
  }

  @media (max-width: 1023px) {
    ${tw`w-full flex justify-center items-center`};

    .slick-list {
      width: 360px;
      ${tw`mb-12`};
    }

    .slick-slider {
      position: relative;
      z-index: 0;
    }

    .slick-prev {
      left: -57px;
      bottom: 0px !important;
    }

    .slick-next {
      right: -68px;
      bottom: 0px !important;
    }

    li.slick-active > button::before {
      color: #fff !important;
    }

    li > button::before {
      color: #e5ecff !important;
      height: 6px !important;
      width: 6px !important;
    }

    .active {
      color: #fff;
      width: 18px;
    }

    .slick-dots {
      bottom: 0px;
    }

    .slick-slide > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const Image = styled.img``;

export const StyledDot = styled('div')`
  height: 6px;
  width: ${(props) => (props.isCurrentSlide ? '16px' : '5px')};
  background-color: ${(props) =>
    props.isCurrentSlide ? colors.white : colors.zumthor};
  opacity: ${(props) => (props.isCurrentSlide ? 1 : 0.3)};
  border-radius: ${(props) => (props.isCurrentSlide ? '3px' : '50%')};
`;
